import { SignedIn, SignedOut, useAuth } from "@clerk/clerk-react";
import React from "react";
import { Navigate } from "react-router-dom";
import Spinner from "../../../components/atoms/Spinner";

/**
 * ProtectedRoute - Component to protect routes that require authentication
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Components to render when authenticated
 * @param {string} props.redirectTo - Path to redirect to when not authenticated
 */
function ProtectedRoute({ children, redirectTo = "/welcome" }) {
  const { isLoaded, isSignedIn } = useAuth();

  // Show loading state while Clerk loads
  if (!isLoaded) {
    return (
      <div className="min-h-screen bg-[--elita-background] flex items-center justify-center">
        <div className="flex flex-col items-center">
          <Spinner size="lg" />
          <div className="text-[--elita-primary] text-xl mt-4">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut>
        <Navigate to={redirectTo} replace />
      </SignedOut>
    </>
  );
}

export default ProtectedRoute;
